<template lang="pug">
.content
  .gridcontainer
    .round1
      .info(v-if="round1.games[0].players[0]")
        img(:src="round1.games[0].players[0].character")
        label {{round1.games[0].players[0].name}}
        span {{round1.games[0].score1}}
    .round1
      .info(v-if="round1.games[0].players[1]")
        img(:src="round1.games[0].players[1].character")
        label {{round1.games[0].players[1].name}}
        span {{round1.games[0].score2}}
    .medwhite
    .round1
      .info(v-if="round1.games[1].players[0]")
        img(:src="round1.games[1].players[0].character")
        label {{round1.games[1].players[0].name}}
        span {{round1.games[1].score1}}
    .round1
      .info(v-if="round1.games[1].players[1]")
        img(:src="round1.games[1].players[1].character")
        label {{round1.games[1].players[1].name}}
        span {{round1.games[1].score2}}
    .medwhite
    .round1
      .info(v-if="round1.games[2].players[0]")
        img(:src="round1.games[2].players[0].character")
        label {{round1.games[2].players[0].name}}
        span {{round1.games[2].score1}}
    .round1
      .info(v-if="round1.games[2].players[1]")
        img(:src="round1.games[2].players[1].character")
        label {{round1.games[2].players[1].name}}
        span {{round1.games[2].score2}}
    .medwhite
    .round1
      .info(v-if="round1.games[3].players[0]")
        img(:src="round1.games[3].players[0].character")
        label {{round1.games[3].players[0].name}}
        span {{round1.games[3].score1}}
    .round1
      .info(v-if="round1.games[3].players[1]")
        img(:src="round1.games[3].players[1].character")
        label {{round1.games[3].players[1].name}}
        span {{round1.games[3].score2}}
    .white
    .white
    .white.special
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.topOnly
    .white
    .white
    .white
    .white
    .white
    .white.special
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.topOnly
    .white
    .white

    .white
    .white
    .white
    .white
    .white.topOnly
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white.topOnly
    .white
    .white
    .white
    .white

    .medwhite
    .white
    .round1
      .info(v-if="round2.games[0].players[0]")
        img(:src="round2.games[0].players[0].character")
        label {{round2.games[0].players[0].name}}
        span {{round2.games[0].score1}}
    .round1
      .info(v-if="round2.games[0].players[1]")
        img(:src="round2.games[0].players[1].character")
        label {{round2.games[0].players[1].name}}
        span {{round2.games[0].score2}}
    .bigwhite
    .bigwhite
    .round1
      .info(v-if="round2.games[1].players[0]")
        img(:src="round2.games[1].players[0].character")
        label {{round2.games[1].players[0].name}}
        span {{round2.games[1].score1}}
    .round1
      .info(v-if="round2.games[1].players[1]")
        img(:src="round2.games[1].players[1].character")
        label {{round2.games[1].players[1].name}}
        span {{round2.games[1].score2}}
    .medwhite
    .white

    .white
    .white
    .white
    .white
    .white
    .white.special
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.rightOnly
    .white.topOnly
    .white
    .white
    .white
    .white

    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white.topOnly
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white

    .bigwhite
    .bigwhite
    .white
    .round1
      .info(v-if="round3.games[0].players[0]")
        img(:src="round3.games[0].players[0].character")
        label {{round3.games[0].players[0].name}}
        span {{round3.games[0].score1}}
    .round1
      .info(v-if="round3.games[0].players[1]")
        img(:src="round3.games[0].players[1].character")
        label {{round3.games[0].players[1].name}}
        span {{round3.games[0].score2}}
    .white
    .bigwhite
    .bigwhite

    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white.rightOnly
    .white.topOnly
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white

    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white.topOnly
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white
    .white

    .bigwhite
    .bigwhite
    .white
    .round1.final
      .info(v-if="final.games[0].players[0]")
        img(:src="final.games[0].players[0].character")
        label {{final.games[0].players[0].name}}
        span {{final.games[0].score1}}
    .round1.final
      .info(v-if="final.games[0].players[1]")
        img(:src="final.games[0].players[1].character")
        label {{final.games[0].players[1].name}}
        span {{final.games[0].score2}}
    .white
    .bigwhite
    .bigwhite

</template>

<script>
import Event from '../event.js';
export default {
  name: "BracketComponent",
  props: {
    names: {
      type: Array,
      required: true
    }
  },
  data : function() {
    return this.initState();
  },
  methods: {
    resetComponent() {
      Object.assign(this.$data, this.initState());
    },
    initState() {
      return {
        round1: {
          games: [ {players: [], score1: undefined, score2: undefined}, {players: [], score1: undefined, score2: undefined}, {players: [], score1: undefined, score2: undefined}, {players: [], score1: undefined, score2: undefined} ],
        },
        round2: {
          games: [{players: [], score1: undefined, score2: undefined}, {players: [], score1: undefined, score2: undefined}, {players: [], score1: undefined, score2: undefined}, {players: [], score1: undefined, score2: undefined},],
        },
        round3: {
          games: [{players: [], score1: undefined, score2: undefined}],
        },
        final: {
          games: [{players: [], score1: undefined, score2: undefined}],
        },
        bracketWinner: undefined,
        sec: undefined,
        third: undefined,
        players: [],
        gameStatus: 'round1',
        encore: false,
      }
    },
    fill(players) {
      let shuffled = this.shuffle(this.players);
      console.log(shuffled);
      let index = 0;
      this.round1.games.forEach((game) => {
        game.players.push(shuffled[index]);
        index++;
      });
      this.round1.games.forEach((game) => {
        game.players.push(shuffled[index]);
        index++;
      });
      console.log(this.round1);
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    },
    endGameFirstRound(first, second) {
      let toPlay = this.round1.games.filter((game) => typeof game.score1 === 'undefined' && typeof game.score2 === 'undefined');
      let game = toPlay[0];
      game.score1 = first;
      game.score2 = second;
      this.round2.games.some((spel) => {
        if(spel.players.length < 2) {
          let result = this.findResult(game);
          spel.players.push(result[0]);
          Event.$emit('To Loserbracket', result[1]);
          console.log(this.round2);
          return true;
        }
      });
      if(toPlay.length === 1) {
        this.gameStatus = 'round2';
      }
      this.findNextGame();
    },
    endGameSecondRound(first, second) {
      let toPlay = this.round2.games.filter((game) => typeof game.score1 === 'undefined' && typeof game.score2 === 'undefined');
      let game = toPlay[0];
      game.score1 = first;
      game.score2 = second;
      let spel = this.round3.games[0];
      if(spel.players.length < 2) {
        let result = this.findResult(game);
        spel.players.push(result[0]);
        if(spel.players.length == 2) {
          this.gameStatus = 'round3';
        }
        Event.$emit('To Loserbracket', result[1]);
      } else {
        console.log('something went wrong');
      }
      this.findNextGame();
    },
    endGameThirdRound(first, second) {
      let game = this.round3.games[0];
      game.score1 = first;
      game.score2 = second;
      let result = this.findResult(game);
      this.final.games[0].players.push(result[0]);
      this.gameStatus = 'final';
      Event.$emit('To Loserbracket', result[1]);
      this.findNextGame();
    },
    endFinalRound(first, second) {
      let game = this.final.games[0];
      game.score1 = first;
      game.score2 = second;
      if(game.score1 > game.score2) {
        this.bracketWinner = game.players[0];
        this.sec = game.players[1];
        Event.$emit('champion', this.bracketWinner);
        let out = [this.bracketWinner, this.sec, this.third ];
        Event.$emit('scores', out);
      }else if(game.score2 > game.score1 && this.encore) {
        this.bracketWinner = game.players[1];
        this.sec = game.players[0];
        Event.$emit('champion', this.bracketWinner);
        let out = [this.bracketWinner, this.sec, this.third ];
        Event.$emit('scores', out);
      } else {
        this.encore = !this.encore;
        this.bracketWinner = game.players[1];
      }
    },
    findResult(game) {
      if(game.score1 > game.score2) {
        return [game.players[0], game.players[1]];
      } else {
        return [game.players[1], game.players[0]];
      }
    },
    findNextGame() {
      let game;
      if(this.gameStatus == 'round1') {
        game = this.round1.games.filter((game) => typeof game.score1 === 'undefined' && typeof game.score2 === 'undefined')[0];
      } else if(this.gameStatus == 'round2') {
        game = this.round2.games.filter((game) => typeof game.score1 === 'undefined' && typeof game.score2 === 'undefined')[0];
      } else if(this.gameStatus == 'round3') {
        game = this.round3.games[0];
      } else if(this.gameStatus == 'final') {
        game = this.final.games[0];
      }
      Event.$emit('Next winnergame', game);
    },
  },
  mounted () {
    this.players = this.names;
    this.fill(this.players);
    this.findNextGame();
    Event.$on('To Winnerbracket', (player) => {
      this.final.games[0].players.push(player);
    });
    Event.$on('third', (player) => {
      this.third = player;
    });
    Event.$on('reset', () => {
      this.resetComponent();
      this.players = this.names;
      this.fill(this.players);
      this.findNextGame();
    });
    Event.$on('submitScore', (first, second, turn) => {
      if(turn === 'w'){
        if(this.gameStatus == 'round1') {
          this.endGameFirstRound(first, second);
        }
        else if(this.gameStatus == 'round2') {
          console.log('round2 boy');
          this.endGameSecondRound(first, second);
        } else if(this.gameStatus == 'round3') {
          this.endGameThirdRound(first, second);
        } else if(this.gameStatus == 'final') {
          this.endFinalRound(first, second);
        }
      }
    });
  }
}
</script>

<style lang="scss">
  .gridcontainer{
    display: grid;
    grid-template-columns: 20% 3% 3% 20% 3% 3% 20% 3% 3% 20%;
    grid-template-rows: repeat(22, 4.5%);
    grid-auto-flow: column;
    padding: 10px;
    width: 90%;
    height: 400px;
    margin-left: 5%;
    //margin-right: 10%;

    .round1{
      text-align: center;
      font-size: 30px;
      grid-row: span 2;
      border: 1px solid black;
      background: linear-gradient(to right, #9F1002, #000000);
      .info{
        background: linear-gradient(to right, #9F1002, #1E0906);
        height: 100%;
      }
      .won{
          background-color: darkgreen;
        }
      img{
        height: 100%;
        float: left;
      }
      label{
        font-size: 30px;
        vertical-align: center;
      }
      button{
        float: right;
        vertical-align: center;
        height: 100%;
        font-size: 30px;
        background-color: transparent;
        color: white;
        padding: 5px;
      }
      button:disabled, button[disabled]{
        background-color: gray;
      }
      button:hover:enabled{
          background-color: indigo;
          cursor: pointer;
        }
    }
    .final {
        background: linear-gradient(to right, blue, #E6A71F);
        .info{
        background: linear-gradient(to right, blue, #E6A71F);
        height: 100%;
      }
      }
    /*.bracket{
      height: 50px;
      width: 200px;
      margin-left: 30px;
      margin-right: 30px;
    }*/

    .white{
      // border: 1px solid gray;
      background: transparent;
    }
    .special{
        border-top: 2px solid blue;
        border-right: 2px solid blue;
        background: transparent;
      }
    .rightOnly{
      border-right: 2px solid blue;
    }
    .topOnly{
      border-top: 2px solid blue;
    }
    .bigwhite{
      border: 1px solid black;
      background: transparent;
      grid-row: span 4;
    }
    .medwhite{
      border: 1px solid black;
      background: transparent;
      grid-row: span 2;
    }
  }

  span {
    float: right;
    background: #4c0000;
    color: white;
    margin-top: 1px;
    margin-bottom: 1px;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 28px;
    border-radius: 25px;
  }

</style>
